import {
  Autocomplete,
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  Divider,
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  // Grid,
  TextField,
  Typography,
  CircularProgress,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useRef, useState } from "react";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import Styles from "./Employee.module.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";

import AddIcon from "@mui/icons-material/Add";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import EditIcon from "@mui/icons-material/Edit";
import Badge from "@mui/icons-material/Badge";
import CreditCard from "@mui/icons-material/CreditCard";
import School from "@mui/icons-material/School";
import Article from "@mui/icons-material/Article";
import Description from "@mui/icons-material/Description";
import CloudUpload from "@mui/icons-material/CloudUpload";
import Visibility from "@mui/icons-material/Visibility";
import Delete from "@mui/icons-material/Delete";
import { updateEmployee, getUserById } from "../../services/user.service";
import { ToastError, ToastSuccess } from "../../utils/Toaster/Toaster";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import NoProfile from "../../assets/images/No_Profile.svg";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  getEmployeeDepartment,
  getEmployeeQualification,
  getEmployeeRole,
  getEmployeeStatus,
  getEmployeeType,
} from "../../services/employee.service";
import { jwtDecode } from "jwt-decode";
import { getProject } from "../../services/project.service";
import Delete_Icon from "../../assets/images/Task_File_Delete_Icon.svg";
import { getAllShift } from "../../services/shifts.service";
import { encryptData } from "../../utils/cryptoUtils";
import { useAuth } from "../../context/AuthProvider";
import CommonLoader from "../../common/CommonLoader/CommonLoader";
import { isAdminRole } from "../../utils/roles";

// import ChangePassword from "../User/ChangePassword";
// import ResetPassword from "../User/ResetPassword";

const EditEmployee = () => {
  const location = useLocation();
  const { accessToken } = useAuth();
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("id");
  const [selectedData, setSelectedData] = useState(location.state?.selectedData || {});
  const [loading, setLoading] = useState(!location.state?.selectedData && userId);
  const [isSaving, setIsSaving] = useState(false);
  //const who = localStorage.getItem("isOverAllAdmin");
  const formType = location.state?.formType;
  const navigate = useNavigate();
  const [who, setIsWho] = useState(false);
  const [value, setValue] = useState("1");
  const [projectData, setProjectData] = useState([]);
  const [departmentData, setDepartmentData] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [shiftData, setShiftData] = useState([]);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState(null);
  const [roleData, setRoleData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  const [typeData, setTypeData] = useState([]);
  const [educationQualification, setEducationQualification] = useState([]);
  // const [openDrawer, setOpenDrawer] = useState(false);
  // const [openResetDrawer, setOpenResetDrawer] = useState(false);
  const disabled = formType === "view" || who === "false";

  useEffect(() => {
    const fetchUserData = async () => {
      if (userId && !location.state?.selectedData) {
        try {
          setLoading(true);
          const res = await getUserById(userId);
          setSelectedData(res?.data?.data || {});
        } catch (error) {
          console.error("Error fetching user data:", error);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchUserData();
  }, [userId]);

  useEffect(() => {
    // const token = localStorage.getItem("token");
    if (accessToken) {
      try {
        const decodedToken = jwtDecode(accessToken);
        setIsWho(isAdminRole(decodedToken.role));
      } catch (error) {
        console.error("Error decoding token:", error);
      }
    }
  }, []);
  console.log("Current Role (who):", who);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [educationRows, setEducationRows] = useState(
    selectedData?.educationField
  );

  // const education = {};

  // Iterate over the data and restructure it based on the qualification
  // educationRows.forEach((item) => {
  //   const qualification = item.qualification.toLowerCase(); // Use the qualification as key
  //   education[qualification] = {
  //     institution: item.institution,
  //     board: item.board,
  //     year: parseInt(item.year, 10), // Convert year to a number
  //     percentage: parseFloat(item.percentage), // Convert percentage to a number
  //   };
  // });
  // Object.entries(educationRows).forEach(([key, item]) => {
  //   const qualification = item.qualification.toLowerCase(); // Convert the key to lowercase (e.g., 'tenth', 'twelfth')

  //   education[qualification] = {
  //     institution: item.institution,
  //     board: item.board,
  //     year: parseInt(item.year, 10), // Convert year to a number
  //     percentage: parseFloat(item.percentage), // Convert percentage to a number
  //   };
  // });

  // console.log(education, "rrrrrrrreeeesult");

  const [newEducationRow, setNewEducationRow] = useState({
    qualification: "",
    institution: "",
    board: "",
    year: "",
    percentage: "",
  });

  const handleAddEducationRow = () => {
    setNewEducationRow({
      qualification: "",
      institution: "",
      board: "",
      year: "",
      percentage: "",
    });
  };

  const handleInputChangeEdu = (e, field) => {
    setNewEducationRow({
      ...newEducationRow,
      [field]: e.target.value,
    });
  };
  const handleSaveEducationRow = () => {
    if (!newEducationRow.qualification) {
      ToastError("Qualification is required");
      return;
    }
    if (!newEducationRow.qualification.match(/^[a-zA-Z0-9\s.,-]+$/)) {
      ToastError("Please enter a valid Qualification");
      return;
    }
    if (!newEducationRow.institution) {
      ToastError("Institution is required");
      return;
    }
    if (!newEducationRow.institution.match(/^[a-zA-Z0-9\s.,-]+$/)) {
      ToastError("Please enter a valid Institution");
      return;
    }
    if (!newEducationRow.board) {
      ToastError("Board is required");
      return;
    }
    if (!newEducationRow.board.match(/^[a-zA-Z0-9\s.,-]+$/)) {
      ToastError("Please enter a valid Board");
      return;
    }
    if (!newEducationRow.year) {
      ToastError("Year is required");
      return;
    }
    if (!newEducationRow.year.match(/^\d{4}$/)) {
      ToastError("Please enter a valid Year (4 digits)");
      return;
    }
    if (!newEducationRow.percentage) {
      ToastError("Percentage is required");
      return;
    }
    if (!newEducationRow.percentage.match(/^(100|\d{1,2}(\.\d{1,2})?)$/)) {
      ToastError("Please enter a valid Percentage (0-100)");
      return;
    }

    const updatedRows = [...educationRows];
    if (newEducationRow.index !== undefined) {
      updatedRows[newEducationRow.index] = { ...newEducationRow };
    } else {
      updatedRows.push(newEducationRow);
    }
    setEducationRows(updatedRows);
    setNewEducationRow(null);
  };

  const handleCancelEducationRow = () => {
    setNewEducationRow(null);
  };

  const handleEditRow = (index) => {
    const rowToEdit = educationRows[index];
    setNewEducationRow({ ...rowToEdit, index });
  };

  const handleDeleteRow = (index) => {
    const updatedRows = educationRows.filter((_, i) => i !== index);
    setEducationRows(updatedRows);
  };

  // family table
  const [familyRows, setFamilyRows] = useState(selectedData?.familyMembers);
  const [newFamilyRow, setNewFamilyRow] = useState({
    name: "",
    relation: "",
    mobileNo: "",
    occupation: "",
    city: "",
  });

  const handleAddFamilyRow = () => {
    setNewFamilyRow({
      name: "",
      relation: "",
      mobileNo: "",
      occupation: "",
      city: "",
    });
  };

  const handleInputChangeFam = (e, field) => {
    setNewFamilyRow({
      ...newFamilyRow,
      [field]: e.target.value,
    });
  };

  const handleSaveFamilyRow = () => {
    if (!newFamilyRow.name) {
      ToastError("Name is required");
      return;
    }
    if (!newFamilyRow.name.match(/^[a-zA-Z\s.,-]+$/)) {
      ToastError("Please enter a valid Name");
      return;
    }
    if (!newFamilyRow.relation) {
      ToastError("Relation is required");
      return;
    }
    if (!newFamilyRow.relation.match(/^[a-zA-Z\s.,-]+$/)) {
      ToastError("Please enter a valid Relation");
      return;
    }
    if (!newFamilyRow.occupation) {
      ToastError("Occupation is required");
      return;
    }
    if (!newFamilyRow.occupation.match(/^[a-zA-Z\s.,-]+$/)) {
      ToastError("Please enter a valid Occupation");
      return;
    }
    if (!newFamilyRow.city) {
      ToastError("City is required");
      return;
    }
    if (!newFamilyRow.city.match(/^[a-zA-Z0-9\s.,-]+$/)) {
      ToastError("Please enter a valid City");
      return;
    }
    if (!newFamilyRow.mobileNo) {
      ToastError("Mobile number is required");
      return;
    }
    if (!newFamilyRow.mobileNo.match(/^\d{10}$/)) {
      ToastError("Please enter a valid Mobile Number (10 digits)");
      return;
    }

    const updatedRows = [...familyRows];
    if (newFamilyRow.index !== undefined) {
      updatedRows[newFamilyRow.index] = { ...newFamilyRow };
    } else {
      updatedRows.push(newFamilyRow);
    }
    setFamilyRows(updatedRows);
    setNewFamilyRow(null);
  };

  const handleCancelFamilyRow = () => {
    setNewFamilyRow(null);
  };
  const handleEditFamilyRow = (index) => {
    const rowToEdit = familyRows[index];
    setNewFamilyRow({ ...rowToEdit, index });
  };
  const handleDeleteFamilyRow = (index) => {
    const updatedRows = familyRows.filter((_, i) => i !== index);
    setFamilyRows(updatedRows);
  };

  const [experienceRows, setExperienceRows] = useState(
    selectedData?.workExperience
  );

  const [newExperienceRow, setNewExperienceRow] = useState({
    companyName: "",
    job: "",
    employeeType: "",
    joiningDate: null,
    resignationDate: null,
  });
  const handleAddExperienceRow = () => {
    setNewExperienceRow({
      companyName: "",
      job: "",
      employeeType: "",
      joiningDate: null,
      resignationDate: null,
    });
  };
  const handleInputChangeExp = (e, field) => {
    setNewExperienceRow({
      ...newExperienceRow,
      // [field]: e.target.value ? dayjs(e.target.value) : null,
      [field]: e.target.value,
    });
  };

  const handleSaveExperienceRow = () => {
    if (!newExperienceRow.companyName) {
      ToastError("Company Name is required");
      return;
    }
    if (!newExperienceRow.companyName.match(/^[a-zA-Z0-9\s.,-]+$/)) {
      ToastError("Please enter a valid Company Name");
      return;
    }
    if (!newExperienceRow.job) {
      ToastError("Job Title is required");
      return;
    }
    if (!newExperienceRow.job.match(/^[a-zA-Z0-9\s.,-]+$/)) {
      ToastError("Please enter a valid Job Title");
      return;
    }
    if (!newExperienceRow.employeeType) {
      ToastError("Employment Type is required");
      return;
    }
    if (!newExperienceRow.employeeType.match(/^[a-zA-Z0-9\s.,-]+$/)) {
      ToastError("Please enter a valid Employment Type");
      return;
    }
    const updatedJoiningDate = newExperienceRow.joiningDate
      ? dayjs(newExperienceRow.joiningDate).toDate()
      : null;
    const updatedResignationDate = newExperienceRow.resignationDate
      ? dayjs(newExperienceRow.resignationDate).toDate()
      : null;
    const updatedRows = [...experienceRows];

    if (newExperienceRow.index !== undefined) {
      updatedRows[newExperienceRow.index] = {
        ...newExperienceRow,
        joiningDate: updatedJoiningDate,
        resignationDate: updatedResignationDate,
      };
    } else {
      updatedRows.push({
        ...newExperienceRow,
        joiningDate: updatedJoiningDate,
        resignationDate: updatedResignationDate,
      });
    }

    setExperienceRows(updatedRows);

    setNewExperienceRow(null);
  };

  const handleCancelExperienceRow = () => {
    setNewExperienceRow(null);
  };

  const handleEditExperienceRow = (index) => {
    const rowToEdit = experienceRows[index];
    setNewExperienceRow({ ...rowToEdit, index });
  };

  const handleDeleteExperienceRow = (index) => {
    const updatedRows = experienceRows.filter((_, i) => i !== index);
    setExperienceRows(updatedRows);
  };

  const formRef = useRef(null);

  const initialValuesTab1 = {
    firstName: selectedData?.firstName || "",
    lastName: selectedData?.lastName || "",
    email: selectedData?.email || "",
    mobileNo: selectedData?.mobileNo || "",
    secondaryMobileNo: selectedData?.secondaryMobileNo || "",
    file: selectedData?.file || "",
  };

  const initialValuesTab2 = {
    employeeID: selectedData.employeeID || "",
    joiningDate: selectedData.joiningDate ? selectedData.joiningDate : "" || "",
    employeeDetails: {
      employeeDepartment:
        selectedData?.employeeDetails?.employeeDepartment || "",
      employeeRole: selectedData?.employeeDetails?.employeeRole || "",
      employeeStatus: selectedData.employeeDetails?.employeeStatus || "",
      employeeType: selectedData.employeeDetails?.employeeType || "",
      employeeShift: selectedData.employeeDetails?.employeeShift || "",
      memberID: selectedData.employeeDetails?.memberID || "",
      pfNumber: selectedData.employeeDetails?.pfNumber || "",
    },
    availableLeave: {
      earnedLeave: selectedData?.availableLeave?.earnedLeave || "0",
      plannedLeave: selectedData?.availableLeave?.plannedLeave || "0",
      unplannedLeave: selectedData?.availableLeave?.unplannedLeave || "0",
    },
    addEarnedLeave: "",
    addPlannedLeave: "",
    addUnplannedLeave: "",
    project: Array.isArray(selectedData.project)
      ? selectedData.project.map((proj) => proj._id) // Ensure this is an array of IDs
      : [],
  };
  const initialValuesTab3 = {
    panNumber: selectedData.panNumber ? selectedData.panNumber : "" || "",
    bloodGroup: selectedData.bloodGroup ? selectedData.bloodGroup : "" || "",
    dateOfBirth: selectedData.dateOfBirth ? selectedData.dateOfBirth : "" || "",
    gender: selectedData.gender ? selectedData.gender : "" || "",
    maritalStatus: selectedData.maritalStatus
      ? selectedData.maritalStatus
      : "" || "",
    aadhaarNumber: selectedData.aadhaarNumber
      ? selectedData.aadhaarNumber
      : "" || "",
    aadhaarCard: selectedData.aadhaarCard || {},
    panCard: selectedData.panCard || {},
    resume: selectedData.resume || {},
    tenthMarkSheet: selectedData.tenthMarkSheet || {},
    twelfthMarkSheet: selectedData.twelfthMarkSheet || {},
    aadhaarCardFile: null,
    panCardFile: null,
    resumeFile: null,
    tenthMarkSheetFile: null,
    twelfthMarkSheetFile: null,
    address: {
      currentAddress: {
        doorNo_street:
          selectedData.address?.currentAddress?.doorNo_street || "",
        place: selectedData.address?.currentAddress?.place || "",
        pincode: selectedData.address?.currentAddress?.pincode || "",
        district: selectedData.address?.currentAddress?.district || "",
      },
      permanentAddress: {
        doorNo_street:
          selectedData.address?.permanentAddress?.doorNo_street || "",
        place: selectedData.address?.permanentAddress?.place || "",
        pincode: selectedData.address?.permanentAddress?.pincode || "",
        district: selectedData.address?.permanentAddress?.district || "",
      },
    },
  };
  const initialValuesTab4 = {
    emergencyDetails: {
      name: selectedData?.emergencyDetails?.name || "",
      relation: selectedData?.emergencyDetails?.relation || "",
      mobileNo: selectedData?.emergencyDetails?.mobileNo || "",
      secondaryMobileNo:
        selectedData?.emergencyDetails?.secondaryMobileNo || "",
      address: {
        doorNo_street:
          selectedData.emergencyDetails?.address?.doorNo_street || "",
        place: selectedData.emergencyDetails?.address?.place || "",
        pincode: selectedData.emergencyDetails?.address?.pincode || "",
        city: selectedData.emergencyDetails?.address?.city || "",
      },
    },
  };
  const initialValuesTab5 = {
    accountDetails: {
      accountNumber: selectedData.accountDetails?.accountNumber || "",
      accountHolderName: selectedData.accountDetails?.accountHolderName || "",
      bankName: selectedData.accountDetails?.bankName || "",
      bankBranch: selectedData.accountDetails?.bankBranch || "",
      IFSCNumber: selectedData.accountDetails?.IFSCNumber || "",
    },
  };
  const educationOptions = [
    { label: "Tenth", name: "Tenth" },
    { label: "Twelfth", name: "Twelfth" },
    { label: "Diploma", name: "Diploma" },
    { label: "UG Degree", name: "UG Degree" },
    { label: "PG Degree", name: "PG Degree" },
  ];

  const genderOptions = [
    { label: "Male", name: "male" },
    { label: "Female", name: "female" },
  ];

  const getProjectData = async () => {
    try {
      const res = await getProject({ isEnabled: true });
      const configData = res.data.data.map((e) => {
        return {
          ...e,
          label: e.name,
        };
      });
      setProjectData(configData);
    } catch (error) {
      console.log(error);
    }
  };

  const getEmployeeQualificationData = async () => {
    try {
      const res = await getEmployeeQualification();
      const configData = res.data.data.map((e) => {
        return {
          ...e,
          label: e.label,
        };
      });
      setEducationQualification(configData);
    } catch (error) {
      console.log(error);
    }
  };

  const getEmployeeDepartmentData = async () => {
    try {
      const res = await getEmployeeDepartment();
      const configData = res.data.data.map((e) => {
        return {
          ...e,
          label: e.department,
        };
      });
      setDepartmentData(configData);
    } catch (error) {
      console.log(error);
    }
  };

  const getEmployeeRoleData = async (selectedDepartmentId) => {
    if (!selectedDepartmentId) {
      console.log("No department selected.");
      return;
    }

    try {
      const res = await getEmployeeRole({ id: selectedDepartmentId });

      if (res.data.data && Array.isArray(res.data.data)) {
        const configData = res?.data?.data?.map((e) => {
          return {
            ...e,
            label: e.role,
          };
        });

        setRoleData(configData);
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const getEmployeeTypeData = async () => {
    try {
      const res = await getEmployeeType();
      if (res.data.data && Array.isArray(res.data.data)) {
        const configData = res?.data?.data?.map((e) => {
          return {
            ...e,
            label: e.label,
          };
        });
        setTypeData(configData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getEmployeeStatusData = async () => {
    try {
      const res = await getEmployeeStatus();

      if (res.data.data && Array.isArray(res.data.data)) {
        const configData = res?.data?.data?.map((e) => {
          return {
            ...e,
            label: e.label,
          };
        });
        setStatusData(configData);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const statusOption = [
    { label: "A+", name: "A+" },
    { label: "A-", name: "A-" },
    { label: "B+", name: "B+" },
    { label: "B-", name: "B-" },
    { label: "AB+", name: "AB+" },
    { label: "AB-", name: "AB-" },
    { label: "O+", name: "O+" },
    { label: "O-", name: "O-" },
  ];

  const getShiftData = async () => {
    try {
      const res = await getAllShift();
      if (res.data) {
        setShiftData(res.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getShiftData();
  }, []);

  useEffect(() => {
    getEmployeeQualificationData();
    getProjectData();
    getEmployeeDepartmentData();
    getEmployeeStatusData();
    getEmployeeTypeData();
  }, []);

  // UseEffect to fetch roles when the department ID changes
  useEffect(() => {
    if (selectedDepartmentId) {
      getEmployeeRoleData(selectedDepartmentId); // Fetch roles when department ID is selected
    }
  }, [selectedDepartmentId]);

  const [avatarPreview, setAvatarPreview] = useState("");
  const [tempImage, setTempImage] = useState(null);
  const [fileName, setFileName] = useState();
  // formType === "edit"
  //   ? selectedData?.file?.fileName
  //   : "Drag & Drop or click to upload videos"

  const renderFile = (file) => {
    if (tempImage) {
      return (
        <img
          src={tempImage}
          alt={fileName || "Temporary Image"}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            cursor: "pointer",
          }}
        />
      );
    }
    if (!file?.location) return <img src={NoProfile} alt="No_Profile" />;
    return (
      <img
        src={file.location}
        alt={file.fileName || "No Profile"}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          cursor: "pointer",
        }}
      // onClick={() => handleImageClick(file.location)}
      />
    );
  };

  const validationSchema = Yup.object({
    files: Yup.mixed().test(
      "file-required",
      "Profile Image is required",
      function (value) {
        const { file } = this.parent;
        // Check if a new file is uploaded OR if there's an existing file with a location
        return !!value || (!!file && !!file.location);
      }
    ),
    firstName: Yup.string()
      .required("First Name is required")
      .min(3, "First Name should be at least 3 characters"),

    oldPassword: Yup.string()
      .nullable()
      .test(
        "no-numbers",
        "Name should not contain numbers",
        (value) => !value || /^[^0-9]*$/.test(value)
      ),

    lastName: Yup.string().required("Last Name is required"),

    email: Yup.string()
      .required("Please enter email")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Please enter a valid email address"
      )
      .test(
        "is-com",
        "Email must end with .com",
        (value) => value && value.endsWith(".com")
      ),
    mobileNo: Yup.string()
      .required("Mobile Number is required")
      .matches(
        /^[0-9]{10}$/,
        "Mobile Number must be 10 digits and contain only numbers"
      ),
    secondaryMobileNo: Yup.string()
      .required("Secondary Mobile Number is required")
      .matches(
        /^[0-9]{10}$/,
        "Secondary Mobile Number must be 10 digits and contain only numbers"
      ),
    joiningDate: Yup.string().required("Select Joining Date"),
    dateOfBirth: Yup.string().required("Select BirthDay Date"),
    gender: Yup.string().nullable().required("Select Gender"),
    // gender: Yup.string()
    //   .nullable()
    //   .test(
    //     "required-if-not-null",
    //     "Select Gender",
    //     (value) => value !== null || value !== ""
    //   ),
    bloodGroup: Yup.string().required("Select Blood Group"),
    maritalStatus: Yup.string().required("Select Marital Status"),
    // aadhaarNumber: Yup.string()
    //   .required("Enter Aadhar Number")
    //   .nullable()
    //   .matches(/^\d{12}$/, "Aadhar number must be exactly 12 digits"),
    aadhaarNumber: Yup.string()
      .nullable()
      .test(
        "valid-pincode",
        "Aadhar Number must be exactly 12 digits",
        (value) => !value || /^\d{12}$/.test(value) // Checks if it's empty or a valid number
      ),
    panNumber: Yup.string()
      .nullable()
      .test(
        "valid-ifsc",
        "Enter PanNumber",
        (value) => !value || /^[A-Za-z0-9]*$/.test(value)
      ),

    address: Yup.object().shape({
      currentAddress: Yup.object().shape({
        doorNo_street: Yup.string()
          .nullable()
          .test(
            "valid-doorNo-street",
            "Door No / Street is required",
            (value) => !value || /^[A-Za-z0-9\s\\.,:/-]*$/.test(value)
          ),
        place: Yup.string()
          .nullable()
          .test(
            "no-numbers",
            "Place is required",
            (value) => !value || /^[^0-9]*$/.test(value)
          ),
        pincode: Yup.string()
          .nullable() // Allow it to be nullable
          .test(
            "valid-pincode",
            "Pincode must be exactly 6 digits",
            (value) => !value || /^\d{6}$/.test(value) // Checks if it's empty or a valid number
          ),
        district: Yup.string()
          .nullable()
          .test(
            "no-numbers",
            "District is required",
            (value) => !value || /^[^0-9]*$/.test(value)
          ),
      }),
      permanentAddress: Yup.object().shape({
        doorNo_street: Yup.string()
          .nullable()
          .test(
            "valid-doorNo-street",
            "Door No / Street is required",
            (value) => !value || /^[A-Za-z0-9\s\\.,:/-]*$/.test(value)
          ),
        place: Yup.string()
          .nullable()
          .test(
            "no-numbers",
            "Place is required",
            (value) => !value || /^[^0-9]*$/.test(value)
          ),
        pincode: Yup.string()
          .nullable() // Allow it to be nullable
          .test(
            "valid-pincode",
            "Pincode must be exactly 6 digits",
            (value) => !value || /^\d{6}$/.test(value) // Checks if it's empty or a valid number
          ),
        district: Yup.string()
          .nullable()
          .test(
            "no-numbers",
            "District is required",
            (value) => !value || /^[^0-9]*$/.test(value)
          ),
      }),
    }),
    emergencyDetails: Yup.object().shape({
      name: Yup.string()
        .nullable()
        .test(
          "valid-name",
          "Name is required",
          (value) => !value || /^[a-zA-Z\s]*$/.test(value)
        ),
      relation: Yup.string()
        .nullable()
        .test(
          "no-numbers",
          "Relation is required",
          (value) => !value || /^[^0-9]*$/.test(value)
        ),
      mobileNo: Yup.string()
        .nullable() // Allow it to be nullable
        .test(
          "valid-mobileNo",
          "Mobile No must be exactly 10 digits",
          (value) => !value || /^\d{10}$/.test(value) // Checks if it's empty or a valid number
        ),
      secondaryMobileNo: Yup.string()
        .nullable() // Allow it to be nullable
        .test(
          "valid-mobileNo",
          "Mobile No must be exactly 10 digits",
          (value) => !value || /^\d{10}$/.test(value) // Checks if it's empty or a valid number
        ),
      address: Yup.object().shape({
        doorNo_street: Yup.string()
          .nullable()
          .test(
            "valid-doorNo-street",
            "Door No / Street is required",
            (value) => !value || /^[A-Za-z0-9\s\\.,:/-]*$/.test(value)
          ),
        place: Yup.string()
          .nullable()
          .test(
            "no-numbers",
            "Place is required",
            (value) => !value || /^[^0-9]*$/.test(value)
          ),
        pincode: Yup.string()
          .nullable() // Allow it to be nullable
          .test(
            "valid-pincode",
            "Pincode must be exactly 6 digits",
            (value) => !value || /^\d{6}$/.test(value) // Checks if it's empty or a valid number
          ),
        city: Yup.string()
          .nullable()
          .test(
            "no-numbers",
            "City is required",
            (value) => !value || /^[^0-9]*$/.test(value)
          ),
      }),
    }),
    // employeeID: Yup.string().required("Enter Employee ID"),
    employeeDetails: Yup.object().shape({
      employeeDepartment: Yup.string().required("Department is required"),
      employeeRole: Yup.string().required("Select Employee Role"),
      employeeStatus: Yup.string().required("Select Employee Status"),
      employeeType: Yup.string().required("Select Employee Type"),
      employeeShift: Yup.string().required("Select Employee Shift"),
    }),

    // resumeFile: Yup.mixed().nullable().test(
    //   "resume-required",
    //   "Resume is required",
    //   function (value) {
    //     const { resume } = this.parent;
    //     return !!value || (resume && !!resume.location);
    //   }
    // ),

    // aadhaarCardFile: Yup.mixed().nullable().test(
    //   "aadhaar-required",
    //   "Aadhaar Card is required",
    //   function (value) {
    //     const { aadhaarCard } = this.parent;
    //     return !!value || (aadhaarCard && !!aadhaarCard.location);
    //   }
    // ),

    // project: Yup.array()
    //   .of(Yup.string().required("Project Required *"))
    //   .required("Project Required *"),

    accountDetails: Yup.object().shape({
      accountNumber: Yup.string()
        .nullable()
        .test(
          "only-numbers",
          "Account Number is required",
          (value) => !value || /^\d+$/.test(value)
        ),
      accountHolderName: Yup.string()
        .nullable()
        .test(
          "no-numbers",
          "AC Holder Name is required",
          (value) => !value || /^[^0-9]*$/.test(value)
        ),
      bankName: Yup.string()
        .nullable()
        .test(
          "no-numbers",
          "Bank Name is required",
          (value) => !value || /^[^0-9]*$/.test(value)
        ),
      bankBranch: Yup.string()
        .nullable()
        .test(
          "no-numbers",
          "Bank Branch is required",
          (value) => !value || /^[^0-9]*$/.test(value)
        ),
      IFSCNumber: Yup.string()
        .nullable()
        .test(
          "valid-ifsc",
          "Enter IFSC Number",
          (value) => !value || /^[A-Za-z0-9]*$/.test(value)
        ),
    }),

    // oldPassword: Yup.string()
    //   .required("Old Password is required")
    //   .min(6, "Old Password should be at least 6 characters long"),

    // newPassword: Yup.string()
    //   .required("New Password is required")
    //   .min(6, "New Password should be at least 6 characters long"),

    // confirmPassword: Yup.string()
    //   .required("Confirm Password is required")
    //   .oneOf([Yup.ref("newPassword"), null], "Passwords must match"),
  });

  const handleSubmit = async (values) => {
    console.log(values);
    setIsSaving(true);
    try {
      const formData = new FormData();
      const { files, ...bodyData } = values;

      const filteredBodyData = Object.fromEntries(
        Object.entries(bodyData).filter(([key, value]) => value !== "")
      );

      if (Object.keys(educationRows).length) {
        filteredBodyData.educationField = educationRows;
      } else {
        filteredBodyData.educationField = [];
      }
      if (Object.keys(familyRows).length) {
        filteredBodyData.familyMembers = familyRows;
      } else {
        filteredBodyData.familyMembers = [];
      }
      if (Object.keys(experienceRows).length) {
        filteredBodyData.workExperience = experienceRows;
      } else {
        filteredBodyData.workExperience = [];
      }

      // if (files && files.length) {
      //   files.forEach((file) => {
      //     formData.append("files", file);
      //   });
      // }
      if (files) {
        formData.append("files", files);
      }
      if (values.aadhaarCardFile) formData.append("aadhaarCard", values.aadhaarCardFile);
      if (values.panCardFile) formData.append("panCard", values.panCardFile);
      if (values.resumeFile) formData.append("resume", values.resumeFile);
      if (values.tenthMarkSheetFile) formData.append("tenthMarkSheet", values.tenthMarkSheetFile);
      if (values.twelfthMarkSheetFile) formData.append("twelfthMarkSheet", values.twelfthMarkSheetFile);

      const fieldsToEncrypt = [
        "firstName",
        "lastName",
        "email",
        "mobileNo",
        "secondaryMobileNo",
        "panNumber",
        "aadhaarNumber",
        "joiningDate",
        "bloodGroup",
        "gender",
      ];

      fieldsToEncrypt.forEach((field) => {
        if (filteredBodyData[field]) {
          filteredBodyData[field] = encryptData(filteredBodyData[field]);
        }
      });

      formData.append("bodyData", JSON.stringify(filteredBodyData));
      // formData.append("education", JSON.stringify(education));
      // if (files && files.length) {
      //   files.forEach((file) => {
      //     formData.append("files", file);
      //   });
      // }

      const apiMethod = updateEmployee(selectedData._id, formData);
      const res = await apiMethod;
      ToastSuccess(res.message);
      navigate(`/home/employeeDetails?id=${selectedData._id}`);
      // setOpenDrawer(false);
      // GetData();
    } catch (error) {
      ToastError(error?.data?.message);
    } finally {
      setIsSaving(false);
    }
  };

  const top100Films = [
    { label: "The Shawshank Redemption", year: 1994 },
    { label: "The Godfather", year: 1972 },
    { label: "The Godfather: Part II", year: 1974 },
    { label: "The Dark Knight", year: 2008 },
    { label: "12 Angry Men", year: 1957 },
    { label: "Schindler's List", year: 1993 },
    { label: "Pulp Fiction", year: 1994 },
  ];

  if (loading) {
    return <CommonLoader />;
  }

  return (
    <Card sx={{ p: 2 }} className={Styles.addRenderingContainerPage}>
      <Box>
        <Box className="addContainerHeader">
          <Typography sx={{ fontSize: "18px", fontWeight: "700", pb: 1 }}>
            {formType === "edit" ? "Edit " : "View "}
            Profile
          </Typography>
        </Box>
        <TabContext value={value}>
          <Box
            sx={{
              "& .MuiTabs-indicator": {
                backgroundColor: "#008080",
                height: "3px",
                borderRadius: "100px",
              },
              "& .MuiTab-root": {
                textTransform: "none",
                color: "#555",
              },
              "& .Mui-selected": {
                color: "#008080 !important",
              },
            }}
          >
            <TabList
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              onChange={handleChange}
              aria-label="Edit Employee Tabs"
            >
              <Tab
                label={
                  <div>
                    <span>Account Details</span>
                    <span style={{ color: "red" }}> *</span>
                  </div>
                }
                value="1"
              />
              <Tab label="Employee Details" value="2" />
              <Tab
                label={
                  <div>
                    <span>Personal Information</span>
                    <span style={{ color: "red" }}> *</span>
                  </div>
                }
                value="3"
              />
              <Tab label="Emergency Contact" value="4" />
              <Tab label="Bank Account Details" value="5" />
            </TabList>
          </Box>
          <Formik
            initialValues={{
              ...initialValuesTab1,
              ...initialValuesTab2,
              ...initialValuesTab3,
              ...initialValuesTab4,
              ...initialValuesTab5,
            }} // Combine both tab initial values
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            {({ touched, errors, setFieldValue, values, submitCount }) => {
              const hasErrors = Object.keys(errors).length > 0 && submitCount > 0;
              return (
                <Form>
                  <Box className="form-container">
                    {value === "1" && (
                      <>
                        <Box className={Styles.tableContent}>
                          <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 5.5 }} mt={1}>
                              <Grid size={{ xs: 12, sm: 12 }} mt={3}>
                                <Stack
                                  className={Styles.avatar}
                                  spacing={2}
                                  sx={{
                                    display: "flex",
                                    justifyContent: "ceneter",
                                    alignItems: "center",
                                  }}
                                >
                                  <Grid>
                                    <Box
                                      sx={{
                                        display: "flex", // To center the content
                                        justifyContent: "center", // Center avatar horizontally
                                        alignItems: "center", // Center avatar vertically
                                        position: "relative", // To position the delete icon properly
                                      }}
                                    >
                                      {/* {selectedData?.file ? (
                                      <> */}
                                      <Avatar
                                        sx={{
                                          width: 90, // Set the width of the avatar
                                          height: 90, // Set the height of the avatar (should match width for a circle)
                                          borderRadius: "50%", // Ensure the avatar is circular
                                          overflow: "hidden",
                                        }}
                                      >
                                        {renderFile(values?.file)}{" "}
                                      </Avatar>
                                      {/* <Box className={Styles.Trash}>
                                  <img src={Trash} alt="Trash Icon" />
                                </Box> */}
                                      {/* </>
                                    ) : (
                                      <div className="">
                                        <Avatar
                                          sx={{
                                            width: "50px",
                                            height: "50px",
                                            borderRadius: "50%",
                                            overflow: "hidden",
                                          }}
                                        >
                                          {selectedData.firstName[0] +
                                            selectedData.lastName[0]}
                                        </Avatar>
                                      </div>
                                    )} */}
                                      <Box
                                        sx={{
                                          position: "absolute", // Position it on top of the avatar
                                          top: 0,
                                          right: 0,
                                          cursor: "pointer", // Make the icon clickable
                                          padding: "4px", // Padding for the icon (optional)
                                        }}
                                      >
                                        {formType === "edit" && (
                                          <img
                                            src={Delete_Icon}
                                            alt={"Delete_Icon"}
                                            onClick={() => {
                                              setFieldValue("file", null);
                                              setTempImage(null);
                                            }}
                                            // disabled={disabled}
                                            style={{
                                              width: 20,
                                              height: 20,
                                              background: "#DBDADA",
                                              borderRadius: "50%",
                                              color: "red",
                                              padding: 2,
                                            }}
                                          />
                                        )}
                                      </Box>
                                    </Box>
                                  </Grid>
                                  {formType === "edit" ? (
                                    <Button
                                      className="Add-Button-Popup"
                                      component="label"
                                      startIcon={<BorderColorOutlinedIcon />}
                                    // disabled={disabled}
                                    >
                                      Upload Photo
                                      <input
                                        type="file"
                                        hidden
                                        onChange={(e) => {
                                          const files = e.target.files[0];
                                          if (files) {
                                            // Generate a temporary URL for preview
                                            const tempUrl =
                                              URL.createObjectURL(files);
                                            setTempImage(tempUrl);
                                            setFileName(files.name);
                                            setFieldValue("files", files);
                                          }
                                        }}
                                      />
                                    </Button>
                                  ) : (
                                    <Button />
                                  )}
                                  {/* </Grid> */}
                                </Stack>
                                <div
                                  className="form-error"
                                  style={{
                                    textAlign: "center",
                                    marginTop: "5px",
                                  }}
                                >
                                  {(touched.files || submitCount > 0) &&
                                    errors.files &&
                                    errors.files}
                                </div>
                              </Grid>
                              <Grid size={{ xs: 12, sm: 12 }} mt={1}>
                                <Typography className="inputLabel">
                                  First Name{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Typography>
                                <Field
                                  name="firstName"
                                  className="InputField"
                                  placeholder="Enter First Name"
                                // disabled={disabled}
                                />
                                <div className="form-error">
                                  {touched.firstName &&
                                    errors.firstName &&
                                    errors.firstName}
                                </div>
                              </Grid>
                              <Grid size={{ xs: 12, sm: 12 }} mt={1}>
                                <Typography className="inputLabel">
                                  Last Name{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Typography>
                                <Field
                                  name="lastName"
                                  className="InputField"
                                  placeholder="Enter First Name"
                                // disabled={disabled}
                                />
                                <div className="form-error">
                                  {touched.lastName &&
                                    errors.lastName &&
                                    errors.lastName}
                                </div>
                              </Grid>
                            </Grid>
                            <Grid
                              display={{ xs: "none", md: "flex" }}
                              alignItems={"center"}
                              justifyContent={"center"}
                              size={{ md: 1 }}
                            >
                              <Divider
                                orientation="vertical"
                                sx={{
                                  borderRight: "2px solid #E4E4E7",
                                  height: "50vh",
                                  marginY: "7",
                                }}
                              />
                            </Grid>

                            <Grid size={{ xs: 12, sm: 5.5 }} mt={1}>
                              <Grid size={{ xs: 12, sm: 12 }} mt={5}>
                                <Typography className="inputLabel">
                                  Email <span style={{ color: "red" }}>*</span>
                                </Typography>
                                <Field
                                  name="email"
                                  className="InputField"
                                  placeholder="Enter Email"
                                  disabled={disabled}
                                />
                                <div className="form-error">
                                  {touched.email &&
                                    errors.email &&
                                    errors.email}
                                </div>
                              </Grid>
                              <Grid
                                size={{ xs: 12, sm: 12 }}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Grid size={{ xs: 12, sm: 6 }} mt={1}>
                                  <Typography className="inputLabel">
                                    Mobile Number{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Typography>
                                  <Field
                                    name="mobileNo"
                                    className="InputField"
                                    placeholder="Enter Mobile Number"
                                    disabled={disabled}
                                  />
                                  <div className="form-error">
                                    {touched.mobileNo &&
                                      errors.mobileNo &&
                                      errors.mobileNo}
                                  </div>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }} mt={1}>
                                  <Typography className="inputLabel">
                                    Secondary Mobile Number{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Typography>
                                  <Field
                                    name="secondaryMobileNo"
                                    className="InputField"
                                    placeholder="Enter Secondary Mobile Number"
                                  // disabled={disabled}
                                  />
                                  <div className="form-error">
                                    {touched.secondaryMobileNo &&
                                      errors.secondaryMobileNo &&
                                      errors.secondaryMobileNo}
                                  </div>
                                </Grid>
                              </Grid>
                              {/* <Grid
                              size={{ xs: 12, sm: 12 }}
                              mt={3}
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              {who === "true" ? (
                                <Button
                                  sx={{ fontSize: "14px", fontWeight: "700" }}
                                  className="Add-Button-Popup"
                                  onClick={() => setOpenResetDrawer(true)}
                                  // disabled={disabled}
                                >
                                  Reset Password
                                </Button>
                              ) : (
                                <Button
                                  sx={{ fontSize: "14px", fontWeight: "700" }}
                                  onClick={() => setOpenDrawer(true)}
                                  className="Add-Button-Popup"
                                  // disabled={disabled}
                                >
                                  Change Password
                                </Button>
                              )}
                            </Grid> */}
                            </Grid>
                          </Grid>
                        </Box>
                      </>
                    )}
                    {value === "2" && (
                      <>
                        <Box className={Styles.tableContent}>
                          <Grid container spacing={2}>
                            <Grid size={{ xs: 12, sm: 6 }} mt={1}>
                              <Grid size={{ xs: 12, sm: 12 }} mt={2}>
                                <Typography className="inputLabel">
                                  Employee ID
                                </Typography>
                                <Field
                                  name="employeeID"
                                  className="InputField w-100"
                                  placeholder="Enter Employee ID"
                                  disabled
                                />
                                <div className="form-error">
                                  {touched.employeeID &&
                                    errors.employeeID &&
                                    errors.employeeID}
                                </div>
                              </Grid>
                              <Grid size={{ xs: 12, sm: 12 }} mt={2}>
                                <Typography className="inputLabel">
                                  Employee Type
                                </Typography>
                                <Autocomplete
                                  options={typeData} // Replace with your type options array
                                  disabled={disabled}
                                  value={
                                    typeData.find(
                                      (type) =>
                                        type.value ===
                                        values?.employeeDetails?.employeeType
                                    ) || null
                                  }
                                  onChange={(e, newValue) =>
                                    setFieldValue(
                                      "employeeDetails.employeeType",
                                      newValue.value || ""
                                    )
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder="Select Type"
                                      className="AutoComplete_InputBox"
                                      variant="outlined"
                                    />
                                  )}
                                />
                                <div className="form-error">
                                  {touched.employeeDetails?.employeeType &&
                                    errors.employeeDetails?.employeeType &&
                                    errors.employeeDetails?.employeeType}
                                </div>
                              </Grid>
                              <Grid size={{ xs: 12, sm: 12 }} mt={2}>
                                <Typography className="inputLabel">
                                  Employee Status
                                </Typography>
                                <Autocomplete
                                  options={statusData} // Replace with your status options array
                                  disabled={disabled}
                                  value={
                                    statusData.find(
                                      (status) =>
                                        status.value ===
                                        values?.employeeDetails?.employeeStatus
                                    ) || null
                                  }
                                  onChange={(e, newValue) => {
                                    setFieldValue(
                                      "employeeDetails.employeeStatus",
                                      newValue.value || ""
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder="Select Status"
                                      className="AutoComplete_InputBox"
                                      variant="outlined"
                                    />
                                  )}
                                />
                                <div className="form-error">
                                  {touched.employeeDetails?.employeeStatus &&
                                    errors.employeeDetails?.employeeStatus &&
                                    errors.employeeDetails?.employeeStatus}
                                </div>
                              </Grid>
                              <Grid size={{ xs: 12, sm: 12 }} mt={2}>
                                <Typography className="inputLabel">
                                  Project
                                </Typography>
                                <Autocomplete
                                  options={projectData}
                                  disableCloseOnSelect
                                  disabled={disabled}
                                  multiple
                                  sx={{}}
                                  value={projectData.filter((option) =>
                                    values.project.includes(option._id)
                                  )}
                                  onChange={(e, v) => {
                                    // setFieldValue("project", v?._id);
                                    setFieldValue(
                                      "project",
                                      v.map((option) => option._id)
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      focused={false}
                                      placeholder={
                                        values.project.length > 0
                                          ? ""
                                          : "Select Project"
                                      }
                                      className="AutoComplete_InputBox"
                                    />
                                  )}
                                />
                                <div className="form-error">
                                  {touched.project &&
                                    errors.project &&
                                    errors.project}
                                </div>
                              </Grid>
                              <Grid
                                size={{ xs: 12, sm: 12 }}
                                // sx={{
                                //   display: "flex",
                                //   justifyContent: "space-between",
                                // }}
                                mt={2}
                              >
                                <Typography className="inputLabel">
                                  Shift
                                </Typography>
                                <Autocomplete
                                  value={
                                    shiftData.find(
                                      (shift) =>
                                        shift._id ===
                                        values?.employeeDetails?.employeeShift
                                    ) || null
                                  }
                                  options={shiftData}
                                  getOptionLabel={(option) =>
                                    option?.shiftName || ""
                                  }
                                  isOptionEqualToValue={(option, value) =>
                                    option._id === value?._id
                                  }
                                  onChange={(e, v) => {
                                    setFieldValue(
                                      "employeeDetails.employeeShift",
                                      v?._id || ""
                                    );
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder="Select Shift"
                                      className="AutoComplete_InputBox"
                                    />
                                  )}
                                  sx={{ width: 300 }}
                                />
                                <div className="form-error">
                                  {touched.employeeDetails?.employeeShift &&
                                    errors.employeeDetails?.employeeShift &&
                                    errors.employeeDetails?.employeeShift}
                                </div>
                              </Grid>
                              <Grid size={{ xs: 12, sm: 12 }} mt={2}>
                                <Typography className="inputLabel">
                                  Member ID
                                </Typography>
                                <Field
                                  name="employeeDetails.memberID"
                                  className="InputField w-100"
                                  placeholder="Enter Member ID"
                                  disabled={disabled}
                                />
                              </Grid>
                              <Grid size={{ xs: 12, sm: 12 }} mt={2}>
                                <Typography className="inputLabel">
                                  PF Number
                                </Typography>
                                <Field
                                  name="employeeDetails.pfNumber"
                                  className="InputField w-100"
                                  placeholder="Enter PF Number"
                                  disabled={disabled}
                                />
                              </Grid>
                            </Grid>
                            <Grid size={{ xs: 12, sm: 6 }} mt={1}>
                              <Grid size={{ xs: 12, sm: 12 }} mt={2}>
                                <Typography className="inputLabel">
                                  Department
                                </Typography>
                                {/* <Autocomplete
                                options={departmentData} // Replace with your role options array
                                value={
                                  values?.employeeDetails?.employeeRole || null
                                }
                                onChange={(e, newValue) =>
                                  setFieldValue(
                                    "employeeDetails.employeeDepartment",
                                    newValue || ""
                                  )
                                }
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Select Department"
                                    className="AutoComplete_InputBox"
                                    variant="outlined"
                                  />
                                )}
                              /> */}
                                <Autocomplete
                                  options={departmentData} // Replace with your department options array
                                  disabled={disabled}
                                  // getOptionLabel={(option) => {
                                  //   console.log(option);
                                  //   return option.label;
                                  // }}
                                  value={
                                    selectedDepartment ||
                                    departmentData?.find(
                                      (option) =>
                                        option._id ===
                                        selectedData?.employeeDetails
                                          ?.employeeDepartment
                                    ) ||
                                    null
                                  }
                                  onChange={(e, newValue) => {
                                    setFieldValue(
                                      "employeeDetails.employeeDepartment",
                                      newValue._id || ""
                                    );

                                    setSelectedDepartment(newValue);
                                    setSelectedDepartmentId(newValue._id);

                                    // If a new department is selected, store its ID and fetch roles
                                    if (newValue?._id) {
                                      getEmployeeRoleData(newValue._id); // Pass the department ID to the role fetching function
                                    } else {
                                      setRoleData([]); // Clear roles if no department is selected
                                    }
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder="Select Department"
                                      className="AutoComplete_InputBox"
                                      variant="outlined"
                                    />
                                  )}
                                />

                                <div className="form-error">
                                  {touched.employeeDetails
                                    ?.employeeDepartment &&
                                    errors.employeeDetails
                                      ?.employeeDepartment &&
                                    errors.employeeDetails?.employeeDepartment}
                                </div>
                              </Grid>
                              <Grid size={{ xs: 12, sm: 12 }} mt={2}>
                                <Typography className="inputLabel">
                                  Role
                                </Typography>
                                <Autocomplete
                                  options={roleData} // Replace with your role options array
                                  disabled={disabled}
                                  // getOptionLabel={(option) => option.label}
                                  // value={
                                  //   values?.employeeDetails?.employeeRole || null
                                  // }

                                  value={
                                    // Ensure the value is set to the full role object, not just the label or id
                                    roleData.find(
                                      (role) =>
                                        role.label ===
                                        values?.employeeDetails?.employeeRole
                                    ) || values?.employeeDetails?.employeeRole
                                  }
                                  onChange={(e, newValue) =>
                                    setFieldValue(
                                      "employeeDetails.employeeRole",
                                      newValue.label || ""
                                    )
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder="Select Role"
                                      className="AutoComplete_InputBox"
                                      variant="outlined"
                                    />
                                  )}
                                />
                                <div className="form-error">
                                  {touched.employeeDetails?.employeeRole &&
                                    errors.employeeDetails?.employeeRole &&
                                    errors.employeeDetails?.employeeRole}
                                </div>
                              </Grid>

                              <Grid size={{ xs: 12, sm: 12 }} mt={2}>
                                <Typography className="inputLabel">
                                  Joining Date
                                </Typography>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <DatePicker
                                    value={
                                      values?.joiningDate
                                        ? dayjs(values?.joiningDate)
                                        : null
                                    }
                                    onChange={(e) =>
                                      setFieldValue("joiningDate", dayjs(e.$d))
                                    }
                                    className="datePicker w-100"
                                    format="DD/MM/YYYY"
                                    disabled={disabled}
                                    slots={{
                                      openPickerIcon: CalendarTodayRoundedIcon,
                                    }}
                                  />
                                </LocalizationProvider>
                                <div className="form-error">
                                  {touched.joiningDate &&
                                    errors.joiningDate &&
                                    errors.joiningDate}
                                </div>
                              </Grid>
                              <Grid
                                size={{ xs: 12, sm: 12 }}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                                mt={2}
                              >
                                <Grid size={{ xs: 12, sm: 6 }}>
                                  <Typography className="inputLabel">
                                    Available Earned Leave
                                  </Typography>
                                  <Field
                                    name="availableLeave.earnedLeave"
                                    className="InputField w-100"
                                    disabled
                                    placeholder="Available Earned Leave"
                                  />
                                </Grid>
                                {who && (
                                  <Grid size={{ xs: 12, sm: 6 }}>
                                    <Typography className="inputLabel">
                                      Add Earned Leave
                                    </Typography>
                                    <Field
                                      name="addEarnedLeave"
                                      className="InputField w-100"
                                      placeholder="Enter Earned Leave"
                                      disabled={who === false}
                                    />
                                  </Grid>
                                )}
                                {/* <div className="form-error">
                                  {touched.earnedLeave &&
                                    errors.earnedLeave &&
                                    errors.earnedLeave}
                                </div> */}
                              </Grid>
                              <Grid
                                size={{ xs: 12, sm: 12 }}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                                mt={2}
                              >
                                <Grid size={{ xs: 12, sm: 6 }}>
                                  <Typography className="inputLabel">
                                    Available Planned Leave
                                  </Typography>
                                  <Field
                                    name="availableLeave.plannedLeave"
                                    className="InputField w-100"
                                    placeholder="Available Planned Leave"
                                    disabled
                                  />
                                </Grid>
                                {who && (
                                  <Grid size={{ xs: 12, sm: 6 }}>
                                    <Typography className="inputLabel">
                                      Add Planned Leave
                                    </Typography>
                                    <Field
                                      name="addPlannedLeave"
                                      className="InputField w-100"
                                      placeholder="Enter Planned Leave"
                                    />
                                  </Grid>
                                )}
                              </Grid>
                              <Grid
                                size={{ xs: 12, sm: 12 }}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                                mt={2}
                              >
                                <Grid size={{ xs: 12, sm: 6 }}>
                                  <Typography className="inputLabel">
                                    Available Unplanned Leave
                                  </Typography>
                                  <Field
                                    name="availableLeave.unplannedLeave"
                                    className="InputField w-100"
                                    placeholder="Available Unplanned Leave"
                                    disabled
                                  />
                                </Grid>
                                {who && (
                                  <Grid size={{ xs: 12, sm: 6 }}>
                                    <Typography className="inputLabel">
                                      Add Unplanned Leave
                                    </Typography>
                                    <Field
                                      name="addUnplannedLeave"
                                      className="InputField w-100"
                                      placeholder="Enter Unplanned Leave"
                                    />
                                  </Grid>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                          <Box>
                            <Box
                              sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%",
                                paddingY: "15px",
                              }}
                            >
                              <Typography
                                sx={{ fontSize: "14px", fontWeight: "600" }}
                              >
                                Work Experience
                              </Typography>
                              <AddIcon
                                onClick={handleAddExperienceRow}
                                sx={{ cursor: "pointer" }}
                              />
                            </Box>

                            <TableContainer
                              component={Paper}
                              sx={{
                                border: "1px solid #E2E1E1",
                                borderRadius: "8px",
                              }}
                            >
                              <Table
                                sx={{
                                  minWidth: 650,
                                  border: "1px solid #E2E1E1",
                                }}
                                aria-label="education table"
                              >
                                <TableHead sx={{ backgroundColor: "#FAFAFA" }}>
                                  <TableRow>
                                    <TableCell align="left">
                                      Company Name
                                    </TableCell>
                                    <TableCell align="left">
                                      Job Title/Designation
                                    </TableCell>
                                    <TableCell align="left">
                                      Employment Type
                                    </TableCell>
                                    <TableCell align="left">
                                      Joining Date
                                    </TableCell>
                                    <TableCell align="left">
                                      Resignation Date
                                    </TableCell>
                                    <TableCell>Actions</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {experienceRows?.map((row, index) => (
                                    <TableRow key={index}>
                                      <TableCell
                                        align="left"
                                        sx={{ padding: "10px", pl: 2 }}
                                      >
                                        {row.companyName}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        sx={{ padding: "10px", pl: 2 }}
                                      >
                                        {row.job}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        sx={{ padding: "10px", pl: 2 }}
                                      >
                                        {row.employeeType}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        sx={{ padding: "10px", pl: 2 }}
                                      >
                                        {/* {row.joiningDate} */}
                                        {row.joiningDate
                                          ? dayjs(row.joiningDate).format(
                                            "DD-MM-YYYY"
                                          )
                                          : ""}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        sx={{ padding: "10px", pl: 2 }}
                                      >
                                        {/* {row.resignationDate} */}
                                        {row.resignationDate
                                          ? dayjs(row.resignationDate).format(
                                            "DD-MM-YYYY"
                                          )
                                          : ""}
                                      </TableCell>
                                      <TableCell>
                                        <TableCell align="center">
                                          <Grid
                                            sx={{ display: "flex", gap: 1 }}
                                          >
                                            <IconButton
                                              onClick={() =>
                                                handleEditExperienceRow(index)
                                              }
                                              sx={{ p: 0 }}
                                            >
                                              <EditIcon
                                                sx={{ color: "#1976D2" }}
                                              />
                                            </IconButton>
                                            <IconButton
                                              onClick={() =>
                                                handleDeleteExperienceRow(index)
                                              }
                                              sx={{ p: 0 }}
                                            >
                                              <DeleteForeverIcon
                                                sx={{ color: "red" }}
                                              />
                                            </IconButton>
                                          </Grid>
                                        </TableCell>
                                      </TableCell>
                                    </TableRow>
                                  ))}

                                  {newExperienceRow && (
                                    <TableRow>
                                      <TableCell align="left">
                                        <TextField
                                          value={newExperienceRow.companyName}
                                          onChange={(e) =>
                                            handleInputChangeExp(
                                              e,
                                              "companyName"
                                            )
                                          }
                                          placeholder="Company Name "
                                          size="small"
                                          variant="standard"
                                          sx={{
                                            width: "100%",
                                            borderBottom: "1px solid #ccc",
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell align="left">
                                        <TextField
                                          value={newExperienceRow.job}
                                          onChange={(e) =>
                                            handleInputChangeExp(e, "job")
                                          }
                                          placeholder="Enter the job "
                                          size="small"
                                          variant="standard"
                                          sx={{
                                            width: "100%",
                                            borderBottom: "1px solid #ccc",
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell align="left">
                                        <TextField
                                          value={newExperienceRow.employeeType}
                                          onChange={(e) =>
                                            handleInputChangeExp(
                                              e,
                                              "employeeType"
                                            )
                                          }
                                          placeholder="Employee Type"
                                          size="small"
                                          variant="standard"
                                          sx={{
                                            width: "100%",
                                            borderBottom: "1px solid #ccc",
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell align="left">
                                        <LocalizationProvider
                                          dateAdapter={AdapterDayjs}
                                        >
                                          <DatePicker
                                            value={
                                              newExperienceRow.joiningDate
                                                ? dayjs(
                                                  newExperienceRow.joiningDate
                                                )
                                                : null
                                            }
                                            onChange={(date) => {
                                              handleInputChangeExp(
                                                {
                                                  target: {
                                                    value: date
                                                      ? date.toISOString()
                                                      : null,
                                                  },
                                                },
                                                "joiningDate"
                                              );
                                            }}
                                            sx={{
                                              "& .MuiInputBase-root": {
                                                backgroundColor: "transparent", // Makes the background transparent
                                                border: "none", // Removes the border
                                              },
                                              "& .MuiOutlinedInput-notchedOutline":
                                              {
                                                border: "none", // Removes the outline border
                                                borderBottom:
                                                  "2px solid #9f9b9b",
                                                borderRadius: 0,
                                              },
                                            }}
                                            slots={{
                                              openPickerIcon:
                                                CalendarTodayRoundedIcon,
                                            }}
                                          />
                                        </LocalizationProvider>
                                      </TableCell>
                                      <TableCell align="left">
                                        <LocalizationProvider
                                          dateAdapter={AdapterDayjs}
                                        >
                                          <DatePicker
                                            value={
                                              newExperienceRow.resignationDate
                                                ? dayjs(
                                                  newExperienceRow.resignationDate
                                                )
                                                : null
                                            }
                                            onChange={(date) => {
                                              handleInputChangeExp(
                                                {
                                                  target: {
                                                    value: date
                                                      ? date.toISOString()
                                                      : null,
                                                  },
                                                }, // Convert to ISO string when saving
                                                "resignationDate"
                                              );
                                            }}
                                            sx={{
                                              "& .MuiInputBase-root": {
                                                backgroundColor: "transparent", // Makes the background transparent
                                                border: "none", // Removes the border
                                              },
                                              "& .MuiOutlinedInput-notchedOutline":
                                              {
                                                border: "none", // Removes the outline border
                                                borderBottom:
                                                  "2px solid #9f9b9b",
                                                borderRadius: 0,
                                              },
                                            }}
                                            slots={{
                                              openPickerIcon:
                                                CalendarTodayRoundedIcon,
                                            }}
                                          />
                                        </LocalizationProvider>
                                      </TableCell>
                                      <TableCell align="center">
                                        <Grid sx={{ display: "flex" }}>
                                          <IconButton
                                            onClick={handleSaveExperienceRow}
                                            sx={{ p: 0 }}
                                          >
                                            <SaveIcon
                                              sx={{ color: "#008080" }}
                                            />
                                          </IconButton>
                                          <IconButton
                                            onClick={handleCancelExperienceRow}
                                          >
                                            <DeleteForeverIcon
                                              sx={{ color: "red" }}
                                            />
                                          </IconButton>
                                        </Grid>
                                      </TableCell>
                                    </TableRow>
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Box>
                        </Box>
                      </>
                    )}
                    {value === "3" && (
                      <>
                        <Box className={Styles.tableContent}>
                          <Grid
                            container
                            spacing={2}
                            display={"flex"}
                            width={"100%"}
                          >
                            <Grid size={{ sm: 6 }} spacing={2}>
                              <Grid item xs={12} sm={6} mt={3}>
                                <Typography className="inputLabel">
                                  Date of Birth{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Typography>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <DemoContainer
                                    components={["DatePicker", "DatePicker"]}
                                  >
                                    <DatePicker
                                      value={
                                        values?.dateOfBirth
                                          ? dayjs(values?.dateOfBirth)
                                          : null
                                      }
                                      onChange={(e) =>
                                        setFieldValue(
                                          "dateOfBirth",
                                          dayjs(e.$d).format("MM/DD/YYYY")
                                        )
                                      }
                                      className="datePicker w-100"
                                      // disabled={disabled}
                                      slots={{
                                        openPickerIcon:
                                          CalendarTodayRoundedIcon,
                                      }}
                                    />
                                  </DemoContainer>
                                </LocalizationProvider>
                                <div className="form-error">
                                  {touched.dateOfBirth &&
                                    errors.dateOfBirth &&
                                    errors.dateOfBirth}
                                </div>
                              </Grid>
                              <Grid item xs={12} sm={6} mt={3}>
                                <Typography className="inputLabel">
                                  Blood Group{" "}
                                  <span style={{ color: "red" }}>*</span>
                                </Typography>
                                <Autocomplete
                                  options={statusOption}
                                  // disabled={disabled}
                                  value={
                                    statusOption?.find(
                                      (option) =>
                                        option.name === values.bloodGroup
                                    ) || null
                                  }
                                  onChange={(e, v) =>
                                    setFieldValue("bloodGroup", v?.name)
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder="Select Blood Group"
                                      className="AutoComplete_InputBox"
                                      variant="outlined"
                                    />
                                  )}
                                />
                                <div className="form-error">
                                  {touched.bloodGroup &&
                                    errors.bloodGroup &&
                                    errors.bloodGroup}
                                </div>
                              </Grid>
                              <Grid item xs={12} sm={6} mt={3}>
                                <Typography className="inputLabel">
                                  Aadhaar Number
                                </Typography>
                                <Field
                                  name="aadhaarNumber"
                                  className="InputField"
                                  placeholder="Enter Your Aadhaar Number"
                                // disabled={disabled}
                                />
                                <div className="form-error">
                                  {touched.aadhaarNumber &&
                                    errors.aadhaarNumber &&
                                    errors.aadhaarNumber}
                                </div>
                              </Grid>
                              <Grid container spacing={2}>
                                <Grid size={{ xs: 12, sm: 6 }} mt={3}>
                                  <Typography className="inputLabel">
                                    Residential Address
                                  </Typography>
                                  <Field
                                    name="address.currentAddress.doorNo_street"
                                    className="InputField w-100"
                                    placeholder="Enter Door No & Street"
                                  // disabled={disabled}
                                  />
                                  <div className="form-error">
                                    {touched.address?.currentAddress
                                      ?.doorNo_street &&
                                      errors.address?.currentAddress
                                        ?.doorNo_street &&
                                      errors.address?.currentAddress
                                        ?.doorNo_street}
                                  </div>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }} mt={3}>
                                  <Typography className="inputLabel">
                                    Place
                                  </Typography>
                                  <Field
                                    name="address.currentAddress.place"
                                    className="InputField w-100"
                                    placeholder="Enter Place"
                                  // disabled={disabled}
                                  />
                                  <div className="form-error">
                                    {touched.address?.currentAddress?.place &&
                                      errors.address?.currentAddress?.place &&
                                      errors.address?.currentAddress?.place}
                                  </div>
                                </Grid>
                              </Grid>
                              <Grid container spacing={2}>
                                <Grid size={{ xs: 12, sm: 6 }} mt={3}>
                                  <Typography className="inputLabel">
                                    Permanent Address
                                  </Typography>
                                  <Field
                                    name="address.permanentAddress.doorNo_street"
                                    className="InputField w-100"
                                    placeholder="Enter Door No & Street"
                                  // disabled={disabled}
                                  />
                                  <div className="form-error">
                                    {touched.address?.permanentAddress
                                      ?.doorNo_street &&
                                      errors.address?.permanentAddress
                                        ?.doorNo_street &&
                                      errors.address?.permanentAddress
                                        ?.doorNo_street}
                                  </div>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }} mt={3}>
                                  <Typography className="inputLabel">
                                    Place
                                  </Typography>
                                  <Field
                                    name="address.permanentAddress.place"
                                    className="InputField w-100"
                                    placeholder="Enter Place"
                                  // disabled={disabled}
                                  />
                                  <div className="form-error">
                                    {touched.address?.permanentAddress?.place &&
                                      errors.address?.permanentAddress?.place &&
                                      errors.address?.permanentAddress?.place}
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid size={{ sm: 6 }}>
                              <Grid item xs={12} sm={6} mt={3}>
                                <Typography className="inputLabel">
                                  Gender <span style={{ color: "red" }}>*</span>
                                </Typography>
                                <Autocomplete
                                  options={genderOptions}
                                  // disabled={disabled}
                                  value={
                                    genderOptions?.find(
                                      (option) => option.name === values.gender
                                    ) || null
                                  }
                                  onChange={(e, v) =>
                                    setFieldValue("gender", v?.name || "")
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      placeholder="Select Gender"
                                      className="AutoComplete_InputBox"
                                      variant="outlined"
                                    />
                                  )}
                                />
                                <div className="form-error">
                                  {touched.gender &&
                                    errors.gender &&
                                    errors.gender}
                                </div>
                              </Grid>
                              <Grid item xs={12} sm={6} mt={3}>
                                <div className="wsh-form-control">
                                  <Typography className="inputLabel">
                                    Marital Status{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </Typography>
                                  <Autocomplete
                                    options={["Single", "Married", "Others"]}
                                    // disabled={disabled}
                                    // multiple
                                    value={values.maritalStatus || null}
                                    onChange={(e, v) => {
                                      // setFieldValue("project", v?._id);
                                      setFieldValue("maritalStatus", v);
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        focused={false}
                                        placeholder="Select Marital Status"
                                        className="AutoComplete_InputBox"
                                      />
                                    )}
                                  />
                                  <div className="form-error">
                                    {touched.maritalStatus &&
                                      errors.maritalStatus &&
                                      errors.maritalStatus}
                                  </div>
                                </div>
                              </Grid>
                              <Grid item xs={12} sm={6} mt={3}>
                                <Typography className="inputLabel">
                                  Pan Number
                                </Typography>
                                <Field
                                  name="panNumber"
                                  className="InputField"
                                  placeholder="Enter Pan Number"
                                // disabled={disabled}
                                />
                                <div className="form-error">
                                  {touched.panNumber &&
                                    errors.panNumber &&
                                    errors.panNumber}
                                </div>
                              </Grid>
                              <Grid container spacing={2}>
                                <Grid size={{ xs: 12, sm: 6 }} mt={3}>
                                  <Typography className="inputLabel">
                                    City
                                  </Typography>
                                  <Field
                                    name="address.currentAddress.district"
                                    className="InputField w-100"
                                    placeholder="Enter City"
                                  // disabled={disabled}
                                  />
                                  <div className="form-error">
                                    {touched.address?.currentAddress
                                      ?.district &&
                                      errors.address?.currentAddress
                                        ?.district &&
                                      errors.address?.currentAddress?.district}
                                  </div>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }} mt={3}>
                                  <Typography className="inputLabel">
                                    Pincode
                                  </Typography>
                                  <Field
                                    name="address.currentAddress.pincode"
                                    className="InputField w-100"
                                    placeholder="Enter Pincode"
                                  // disabled={disabled}
                                  />
                                  <div className="form-error">
                                    {touched.address?.currentAddress?.pincode &&
                                      errors.address?.currentAddress?.pincode &&
                                      errors.address?.currentAddress?.pincode}
                                  </div>
                                </Grid>
                              </Grid>
                              <Grid container spacing={2}>
                                <Grid size={{ xs: 12, sm: 6 }} mt={3}>
                                  <Typography className="inputLabel">
                                    City
                                  </Typography>
                                  <Field
                                    name="address.permanentAddress.district"
                                    className="InputField w-100"
                                    placeholder="Enter City"
                                  // disabled={disabled}
                                  />
                                  <div className="form-error">
                                    {touched.address?.permanentAddress
                                      ?.district &&
                                      errors.address?.permanentAddress
                                        ?.district &&
                                      errors.address?.permanentAddress
                                        ?.district}
                                  </div>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }} mt={3}>
                                  <Typography className="inputLabel">
                                    Pincode
                                  </Typography>
                                  <Field
                                    name="address.permanentAddress.pincode"
                                    className="InputField w-100"
                                    placeholder="Enter Pincode"
                                  // disabled={disabled}
                                  />
                                  <div className="form-error">
                                    {touched.address?.permanentAddress
                                      ?.pincode &&
                                      errors.address?.permanentAddress
                                        ?.pincode &&
                                      errors.address?.permanentAddress?.pincode}
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid container spacing={2} mb={1} mt={2}>
                            <Grid size={{ xs: 12 }}>
                              <Paper variant="outlined" sx={{ borderRadius: 2, border: "none" }}>
                                <Grid container spacing={1} columns={10}>
                                  {[
                                    { label: "Aadhaar Card", name: "aadhaarCardFile", existing: "aadhaarCard", icon: Badge },
                                    { label: "Pan Card", name: "panCardFile", existing: "panCard", icon: CreditCard },
                                    { label: "Resume", name: "resumeFile", existing: "resume", icon: Description },
                                    { label: "10th Mark Sheet", name: "tenthMarkSheetFile", existing: "tenthMarkSheet", icon: School },
                                    { label: "12th Mark Sheet", name: "twelfthMarkSheetFile", existing: "twelfthMarkSheet", icon: Article },
                                  ].map((doc, index) => {
                                    const hasFile = values[doc.name];
                                    const hasExisting = values[doc.existing] && values[doc.existing].location;
                                    const isUploaded = hasFile || hasExisting;
                                    const error = touched[doc.name] && errors[doc.name];

                                    return (
                                      <Grid size={{ xs: 10, sm: 5, md: 2 }} key={doc.name}>
                                        <Box
                                          sx={{
                                            p: 1,
                                            borderRadius: 2,
                                            border: "1px solid #e0e0e0",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            textAlign: "center",
                                            gap: 1,
                                            backgroundColor: isUploaded ? "#f0fafa" : "#fff",
                                            borderColor: error ? "red" : (isUploaded ? "#008080" : "#e0e0e0"),
                                            transition: "all 0.2s",
                                            minHeight: "100%"
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              width: "100%",
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center"
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                width: 32,
                                                height: 32,
                                                borderRadius: "6px",
                                                backgroundColor: isUploaded ? "#e0f2f1" : "#f5f5f5",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                              }}
                                            >
                                              <doc.icon sx={{ color: isUploaded ? "#008080" : "#9e9e9e", fontSize: 18 }} />
                                            </Box>
                                            <Typography variant="caption" fontWeight={600} noWrap sx={{ maxWidth: "60%" }} title={doc.label}>
                                              {doc.label}
                                            </Typography>
                                          </Box>

                                          <Typography variant="caption" color="text.secondary" display="block" noWrap sx={{ width: "100%", fontSize: "0.7rem", height: "1.2em" }}>
                                            {hasFile ? hasFile.name : (hasExisting ? "Uploaded" : "No file")}
                                          </Typography>

                                          <Stack direction="row" spacing={0.5} justifyContent="center" width="100%">
                                            {isUploaded ? (
                                              <>
                                                {hasExisting && (
                                                  <IconButton
                                                    href={values[doc.existing].location}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    size="small"
                                                    sx={{ color: '#008080', padding: "2px" }}
                                                    title="View"
                                                  >
                                                    <Visibility sx={{ fontSize: 16 }} />
                                                  </IconButton>
                                                )}

                                                <IconButton
                                                  component="label"
                                                  size="small"
                                                  sx={{ color: '#008080', padding: "2px" }}
                                                  title="Change"
                                                >
                                                  <CloudUpload sx={{ fontSize: 16 }} />
                                                  <input
                                                    type="file"
                                                    hidden
                                                    accept="image/*,application/pdf"
                                                    onChange={(e) => {
                                                      const file = e.target.files[0];
                                                      if (file) setFieldValue(doc.name, file);
                                                    }}
                                                  />
                                                </IconButton>

                                                {(hasFile || hasExisting) && (
                                                  <IconButton
                                                    size="small"
                                                    onClick={() => {
                                                      setFieldValue(doc.name, null);
                                                      setFieldValue(doc.existing, null);
                                                    }}
                                                    sx={{ color: '#ef5350', padding: "2px" }}
                                                    title="Remove"
                                                  >
                                                    <Delete sx={{ fontSize: 16 }} />
                                                  </IconButton>
                                                )}
                                              </>
                                            ) : (
                                              <Button
                                                component="label"
                                                variant="outlined"
                                                size="small"
                                                sx={{
                                                  minWidth: "auto",
                                                  width: "100%",
                                                  px: 1,
                                                  py: 0.2,
                                                  textTransform: 'none',
                                                  borderColor: "#008080",
                                                  color: "#008080",
                                                  fontSize: "0.7rem"
                                                }}
                                              >
                                                Upload
                                                <input
                                                  type="file"
                                                  hidden
                                                  accept="image/*,application/pdf"
                                                  onChange={(e) => {
                                                    const file = e.target.files[0];
                                                    if (file) setFieldValue(doc.name, file);
                                                  }}
                                                />
                                              </Button>
                                            )}
                                          </Stack>
                                        </Box>
                                        {error && (
                                          <Typography variant="caption" color="error" sx={{ mx: 0.5, mt: 0.5, display: "block", fontSize: "0.65rem", lineHeight: 1.1, textAlign: "center" }}>
                                            {error}
                                          </Typography>
                                        )}
                                      </Grid>
                                    );
                                  })}
                                </Grid>
                              </Paper>
                            </Grid>
                          </Grid>
                          <Box>
                            <Box
                              sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%",
                                paddingY: "15px",
                              }}
                            >
                              <Typography
                                sx={{ fontSize: "14px", fontWeight: "600" }}
                              >
                                Education Details
                              </Typography>
                              <AddIcon
                                onClick={handleAddEducationRow}
                                sx={{ cursor: "pointer" }}
                              />
                            </Box>

                            <TableContainer
                              component={Paper}
                              sx={{
                                border: "1px solid #E2E1E1",
                                borderRadius: "8px",
                              }}
                            >
                              <Table
                                sx={{
                                  minWidth: 650,
                                  border: "1px solid #E2E1E1",
                                }}
                                aria-label="education table"
                              >
                                <TableHead sx={{ backgroundColor: "#FAFAFA" }}>
                                  <TableRow>
                                    <TableCell align="left">
                                      Qualification
                                    </TableCell>
                                    <TableCell align="left">
                                      Institution Name
                                    </TableCell>
                                    <TableCell align="left">
                                      Board/University
                                    </TableCell>
                                    <TableCell align="left">
                                      Year Of Completion
                                    </TableCell>
                                    <TableCell align="left">
                                      Percentage
                                    </TableCell>
                                    <TableCell>Actions</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {educationRows?.map((row, index) => (
                                    <TableRow key={index}>
                                      <TableCell
                                        align="left"
                                        sx={{ padding: "10px", pl: 2 }}
                                      >
                                        {row.qualification}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        sx={{ padding: "10px", pl: 2 }}
                                      >
                                        {row.institution}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        sx={{ padding: "10px", pl: 2 }}
                                      >
                                        {row.board}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        sx={{ padding: "10px", pl: 2 }}
                                      >
                                        {row.year}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        sx={{ padding: "10px", pl: 2 }}
                                      >
                                        {row.percentage}
                                      </TableCell>
                                      <TableCell>
                                        <TableCell align="center">
                                          <Grid
                                            sx={{ display: "flex", gap: 1 }}
                                          >
                                            <IconButton
                                              onClick={() =>
                                                handleEditRow(index)
                                              }
                                              sx={{ p: 0 }}
                                            >
                                              <EditIcon
                                                sx={{ color: "#1976D2" }}
                                              />
                                            </IconButton>
                                            <IconButton
                                              onClick={() =>
                                                handleDeleteRow(index)
                                              }
                                              sx={{ p: 0 }}
                                            >
                                              <DeleteForeverIcon
                                                sx={{ color: "red" }}
                                              />
                                            </IconButton>
                                          </Grid>
                                        </TableCell>
                                      </TableCell>
                                    </TableRow>
                                  ))}

                                  {newEducationRow && (
                                    <TableRow>
                                      <TableCell
                                        align="left"
                                        sx={{
                                          padding: 0,
                                          pl: 2,
                                          width: "15%",
                                          pt: 2,
                                        }}
                                      >
                                        <Autocomplete
                                          options={educationQualification}
                                          getOptionLabel={(option) =>
                                            option.label
                                          }
                                          value={educationQualification?.find(
                                            (option) =>
                                              option.label ===
                                              newEducationRow?.qualification
                                          )}
                                          onChange={(event, newValue) => {
                                            const qualificationName = newValue
                                              ? newValue.label
                                              : "";
                                            handleInputChangeEdu(
                                              {
                                                target: {
                                                  value: qualificationName,
                                                },
                                              },
                                              "qualification"
                                            );
                                          }}
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              placeholder="Qualification"
                                              size="small"
                                              variant="standard"
                                              sx={{
                                                width: "100%",
                                                borderBottom: "1px solid #ccc",
                                                mb: 2,
                                              }}
                                            />
                                          )}
                                        />
                                      </TableCell>
                                      <TableCell align="left">
                                        <TextField
                                          value={newEducationRow?.institution}
                                          onChange={(e) =>
                                            handleInputChangeEdu(
                                              e,
                                              "institution"
                                            )
                                          }
                                          placeholder="Institution Name"
                                          size="small"
                                          variant="standard"
                                          sx={{
                                            width: "100%",
                                            borderBottom: "1px solid #ccc",
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell align="left">
                                        <TextField
                                          value={newEducationRow?.board}
                                          onChange={(e) =>
                                            handleInputChangeEdu(e, "board")
                                          }
                                          placeholder="Board/University"
                                          size="small"
                                          variant="standard"
                                          sx={{
                                            width: "100%",
                                            borderBottom: "1px solid #ccc",
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell align="left">
                                        <TextField
                                          value={newEducationRow?.year}
                                          onChange={(e) =>
                                            handleInputChangeEdu(e, "year")
                                          }
                                          placeholder="Year Of Completion"
                                          size="small"
                                          variant="standard"
                                          sx={{
                                            width: "100%",
                                            borderBottom: "1px solid #ccc",
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell align="left">
                                        <TextField
                                          value={newEducationRow?.percentage}
                                          onChange={(e) =>
                                            handleInputChangeEdu(
                                              e,
                                              "percentage"
                                            )
                                          }
                                          placeholder="Percentage"
                                          size="small"
                                          variant="standard"
                                          sx={{
                                            width: "100%",
                                            borderBottom: "1px solid #ccc",
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell align="center">
                                        <IconButton
                                          onClick={handleSaveEducationRow}
                                          sx={{ p: 0 }}
                                        >
                                          <SaveIcon sx={{ color: "#008080" }} />
                                        </IconButton>
                                        <IconButton
                                          onClick={handleCancelEducationRow}
                                        >
                                          <DeleteForeverIcon
                                            sx={{ color: "red" }}
                                          />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Box>
                          <Box>
                            <Box
                              sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%",
                                paddingY: "15px",
                              }}
                            >
                              <Typography
                                sx={{ fontSize: "14px", fontWeight: "600" }}
                              >
                                Family Members
                              </Typography>
                              <AddIcon
                                onClick={handleAddFamilyRow}
                                sx={{ cursor: "pointer" }}
                              />
                            </Box>

                            <TableContainer
                              component={Paper}
                              sx={{
                                border: "1px solid #E2E1E1",
                                borderRadius: "8px",
                              }}
                            >
                              <Table
                                sx={{
                                  minWidth: 650,
                                  border: "1px solid #E2E1E1",
                                }}
                                aria-label="family table"
                              >
                                <TableHead sx={{ backgroundColor: "#FAFAFA" }}>
                                  <TableRow>
                                    <TableCell align="left">
                                      Full Name
                                    </TableCell>
                                    <TableCell align="left">Relation</TableCell>
                                    <TableCell align="left">
                                      Mobile Number
                                    </TableCell>
                                    <TableCell align="left">
                                      Occupation
                                    </TableCell>
                                    <TableCell align="left">Place</TableCell>
                                    <TableCell>Actions</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {familyRows?.map((row, index) => (
                                    <TableRow key={index}>
                                      <TableCell
                                        align="left"
                                        sx={{ padding: "10px", pl: 2 }}
                                      >
                                        {row.name}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        sx={{ padding: "10px", pl: 2 }}
                                      >
                                        {row.relation}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        sx={{ padding: "10px", pl: 2 }}
                                      >
                                        {row.mobileNo}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        sx={{ padding: "10px", pl: 2 }}
                                      >
                                        {row.occupation}
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        sx={{ padding: "10px", pl: 2 }}
                                      >
                                        {row.city}
                                      </TableCell>
                                      <TableCell>
                                        <TableCell align="center">
                                          <Grid
                                            sx={{ display: "flex", gap: 1 }}
                                          >
                                            <IconButton
                                              onClick={() =>
                                                handleEditFamilyRow(index)
                                              }
                                              sx={{ p: 0 }}
                                            >
                                              <EditIcon
                                                sx={{ color: "#1976D2" }}
                                              />
                                            </IconButton>
                                            <IconButton
                                              onClick={() =>
                                                handleDeleteFamilyRow(index)
                                              }
                                              sx={{ p: 0 }}
                                            >
                                              <DeleteForeverIcon
                                                sx={{ color: "red" }}
                                              />
                                            </IconButton>
                                          </Grid>
                                        </TableCell>
                                      </TableCell>
                                      {/* <TableCell>...</TableCell> */}
                                    </TableRow>
                                  ))}

                                  {newFamilyRow && (
                                    <TableRow>
                                      <TableCell align="left">
                                        <TextField
                                          value={newFamilyRow?.name}
                                          onChange={(e) =>
                                            handleInputChangeFam(e, "name")
                                          }
                                          placeholder="Full Name"
                                          size="small"
                                          variant="standard"
                                          sx={{
                                            width: "100%",
                                            borderBottom: "1px solid #ccc",
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell align="left">
                                        <TextField
                                          value={newFamilyRow?.relation}
                                          onChange={(e) =>
                                            handleInputChangeFam(e, "relation")
                                          }
                                          placeholder="Relation"
                                          size="small"
                                          variant="standard"
                                          sx={{
                                            width: "100%",
                                            borderBottom: "1px solid #ccc",
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell align="left">
                                        <TextField
                                          value={newFamilyRow?.mobileNo}
                                          onChange={(e) =>
                                            handleInputChangeFam(e, "mobileNo")
                                          }
                                          placeholder="Mobile Number"
                                          size="small"
                                          variant="standard"
                                          sx={{
                                            width: "100%",
                                            borderBottom: "1px solid #ccc",
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell align="left">
                                        <TextField
                                          value={newFamilyRow?.occupation}
                                          onChange={(e) =>
                                            handleInputChangeFam(
                                              e,
                                              "occupation"
                                            )
                                          }
                                          placeholder="Occupation"
                                          size="small"
                                          variant="standard"
                                          sx={{
                                            width: "100%",
                                            borderBottom: "1px solid #ccc",
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell align="left">
                                        <TextField
                                          value={newFamilyRow?.city}
                                          onChange={(e) =>
                                            handleInputChangeFam(e, "city")
                                          }
                                          placeholder="Place"
                                          size="small"
                                          variant="standard"
                                          sx={{
                                            width: "100%",
                                            borderBottom: "1px solid #ccc",
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell align="center">
                                        <IconButton
                                          onClick={handleSaveFamilyRow}
                                          sx={{ p: 0 }}
                                        >
                                          <SaveIcon sx={{ color: "#008080" }} />
                                        </IconButton>
                                        <IconButton
                                          onClick={handleCancelFamilyRow}
                                        >
                                          <DeleteForeverIcon
                                            sx={{ color: "red", p: 0 }}
                                          />
                                        </IconButton>
                                      </TableCell>
                                    </TableRow>
                                  )}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Box>
                        </Box>
                      </>
                    )}
                    {value === "4" && (
                      <>
                        <Box className={Styles.tableContent}>
                          <Grid
                            container
                            spacing={2}
                            display={"flex"}
                            width={"100%"}
                          >
                            <Grid size={{ sm: 6 }} spacing={2}>
                              <Grid item xs={12} sm={6} mt={3}>
                                <Typography className="inputLabel">
                                  Name
                                </Typography>
                                <Field
                                  name="emergencyDetails.name"
                                  className="InputField"
                                  placeholder="Enter Name"
                                // disabled={disabled}
                                />
                                <div className="form-error">
                                  {touched.emergencyDetails?.name &&
                                    errors.emergencyDetails?.name &&
                                    errors.emergencyDetails?.name}
                                </div>
                              </Grid>
                              <Grid item xs={12} sm={6} mt={3}>
                                <Typography className="inputLabel">
                                  Mobile
                                </Typography>
                                <Field
                                  name="emergencyDetails.mobileNo"
                                  type="number"
                                  className="InputField"
                                  placeholder="Enter Mobile Number"
                                // disabled={disabled}
                                />
                                <div className="form-error">
                                  {touched.emergencyDetails?.mobileNo &&
                                    errors.emergencyDetails?.mobileNo &&
                                    errors.emergencyDetails?.mobileNo}
                                </div>
                              </Grid>
                              <Grid container spacing={2}>
                                <Grid size={{ xs: 12, sm: 6 }} mt={3}>
                                  <Typography className="inputLabel">
                                    Residential Address
                                  </Typography>
                                  <Field
                                    name="emergencyDetails.address.doorNo_street"
                                    className="InputField w-100"
                                    placeholder="Enter Door No & Street"
                                  // disabled={disabled}
                                  />
                                  <div className="form-error">
                                    {touched.emergencyDetails?.address
                                      ?.doorNo_street &&
                                      errors.emergencyDetails?.address
                                        ?.doorNo_street &&
                                      errors.emergencyDetails?.address
                                        ?.doorNo_street}
                                  </div>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }} mt={3}>
                                  <Typography className="inputLabel">
                                    Place
                                  </Typography>
                                  <Field
                                    name="emergencyDetails.address.place"
                                    className="InputField w-100"
                                    placeholder="Enter Place"
                                  // disabled={disabled}
                                  />
                                  <div className="form-error">
                                    {touched.emergencyDetails?.address?.place &&
                                      errors.emergencyDetails?.address?.place &&
                                      errors.emergencyDetails?.address?.place}
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                            <Grid size={{ sm: 6 }}>
                              <Grid item xs={12} sm={6} mt={3}>
                                <Typography className="inputLabel">
                                  Relation
                                </Typography>
                                <Field
                                  name="emergencyDetails.relation"
                                  className="InputField"
                                  placeholder="Enter Relation"
                                // disabled={disabled}
                                />
                                <div className="form-error">
                                  {touched.emergencyDetails?.relation &&
                                    errors.emergencyDetails?.relation &&
                                    errors.emergencyDetails?.relation}
                                </div>
                              </Grid>
                              <Grid item xs={12} sm={6} mt={3}>
                                <Typography className="inputLabel">
                                  Secondary Mobile Number
                                </Typography>
                                <Field
                                  name="emergencyDetails.secondaryMobileNo"
                                  type="number"
                                  className="InputField"
                                  placeholder="Enter Mobile Number"
                                // disabled={disabled}
                                />
                                <div className="form-error">
                                  {touched.emergencyDetails
                                    ?.secondaryMobileNo &&
                                    errors.emergencyDetails
                                      ?.secondaryMobileNo &&
                                    errors.emergencyDetails?.secondaryMobileNo}
                                </div>
                              </Grid>
                              <Grid container spacing={2}>
                                <Grid size={{ xs: 12, sm: 6 }} mt={3}>
                                  <Typography className="inputLabel">
                                    City
                                  </Typography>
                                  <Field
                                    name="emergencyDetails.address.city"
                                    className="InputField w-100"
                                    placeholder="Enter City"
                                  // disabled={disabled}
                                  />
                                  <div className="form-error">
                                    {touched.emergencyDetails?.address?.city &&
                                      errors.emergencyDetails?.address?.city &&
                                      errors.emergencyDetails?.address?.city}
                                  </div>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6 }} mt={3}>
                                  <Typography className="inputLabel">
                                    Pincode
                                  </Typography>
                                  <Field
                                    name="emergencyDetails.address.pincode"
                                    className="InputField w-100"
                                    placeholder="Enter Pincode"
                                  // disabled={disabled}
                                  />
                                  <div className="form-error">
                                    {touched.emergencyDetails?.address
                                      ?.pincode &&
                                      errors.emergencyDetails?.address
                                        ?.pincode &&
                                      errors.emergencyDetails?.address?.pincode}
                                  </div>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      </>
                    )}
                    {value === "5" && (
                      <>
                        <Box className={Styles.tableContent}>
                          <Grid
                            container
                            spacing={2}
                            display={"flex"}
                            width={"100%"}
                          >
                            <Grid size={{ sm: 6 }} spacing={2}>
                              <Grid item xs={12} sm={6} mt={3}>
                                <Typography className="inputLabel">
                                  Account Number
                                </Typography>
                                <Field
                                  name="accountDetails.accountNumber"
                                  className="InputField w-100"
                                  placeholder="Enter Account Number"
                                // disabled={disabled}
                                />
                                <div className="form-error">
                                  {touched.accountDetails?.accountNumber &&
                                    errors.accountDetails?.accountNumber &&
                                    errors.accountDetails?.accountNumber}
                                </div>
                              </Grid>
                              <Grid item xs={12} sm={6} mt={2}>
                                <Typography className="inputLabel">
                                  Bank Name
                                </Typography>
                                <Field
                                  name="accountDetails.bankName"
                                  className="InputField w-100"
                                  placeholder="Enter Bank Name"
                                // disabled={disabled}
                                />
                                <div className="form-error">
                                  {touched.accountDetails?.bankName &&
                                    errors.accountDetails?.bankName &&
                                    errors.accountDetails?.bankName}
                                </div>
                              </Grid>
                              <Grid item xs={12} sm={6} mt={2}>
                                <Typography className="inputLabel">
                                  IFSC No
                                </Typography>
                                <Field
                                  name="accountDetails.IFSCNumber"
                                  className="InputField w-100"
                                  placeholder="Enter IFSC Number"
                                // disabled={disabled}
                                />
                                <div className="form-error">
                                  {touched.accountDetails?.IFSCNumber &&
                                    errors.accountDetails?.IFSCNumber &&
                                    errors.accountDetails?.IFSCNumber}
                                </div>
                              </Grid>
                            </Grid>
                            <Grid size={{ sm: 6 }}>
                              <Grid item xs={12} sm={6} mt={3}>
                                <Typography className="inputLabel">
                                  Account Holder Name
                                </Typography>
                                <Field
                                  name="accountDetails.accountHolderName"
                                  className="InputField w-100"
                                  placeholder="Enter Account Holder Name"
                                // disabled={disabled}
                                />
                                <div className="form-error">
                                  {touched.accountDetails?.accountHolderName &&
                                    errors.accountDetails?.accountHolderName &&
                                    errors.accountDetails?.accountHolderName}
                                </div>
                              </Grid>
                              <Grid item xs={12} sm={6} mt={2}>
                                <Typography className="inputLabel">
                                  Branch
                                </Typography>
                                <Field
                                  name="accountDetails.bankBranch"
                                  className="InputField w-100"
                                  placeholder="Enter Bank Branch"
                                // disabled={disabled}
                                />
                                <div className="form-error">
                                  {touched.accountDetails?.bankBranch &&
                                    errors.accountDetails?.bankBranch &&
                                    errors.accountDetails?.bankBranch}
                                </div>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Box>
                      </>
                    )}
                  </Box>

                  <CardActions className={Styles.CardFooter}>
                    {hasErrors && (
                      <Stack
                        direction={"row"}
                        gap={1}
                        alignItems={"center"}
                        sx={{ color: "red" }}
                      >
                        {" "}
                        <WarningAmberIcon />
                        Fill All The Required Fields
                      </Stack>
                    )}
                    {!formType === "view" ? (
                      <Button
                        className={Styles.cancelButton}
                        // onClick={() => setOpenDrawer(false)}
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        Cancel
                      </Button>
                    ) : (
                      <Button
                        className={Styles.cancelButton}
                        // onClick={() => setOpenDrawer(false)}
                        onClick={() => {
                          navigate(-1);
                        }}
                      >
                        Back
                      </Button>
                    )}
                    {formType === "edit" && (
                      <Button
                        type="submit"
                        className={Styles.saveButton}
                        disabled={isSaving}
                        startIcon={
                          isSaving ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : null
                        }
                      // sx={{
                      //   backgroundColor: hasErrors ? "white" : "#008080",
                      //   color: hasErrors ? "#4d4c4c" : "white",
                      //   border: hasErrors ? "1px solid #e4e4e7" : "none",
                      // }}
                      // onClick={(e) => {
                      //   e.preventDefault(); // Prevents the default form submit behavior
                      //   handleSubmit(e); // Calls handleSubmit with the current values
                      // }}
                      // sx={{ display: disabled ? "none" : "flex" }}
                      >
                        {isSaving ? "Saving..." : "Save"}
                      </Button>
                    )}
                  </CardActions>
                </Form>
              );
            }}
          </Formik>
        </TabContext>
      </Box>
      {/* <Dialog
        open={openDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="xs"
      >
        {openDrawer ? (
          <ChangePassword
            // selectedData={selectedData}
            setOpenDrawer={setOpenDrawer}
            formType={
              selectedData.isView ? "view" : selectedData._id ? "edit" : "add"
            }
            // getData={getClientData}
          />
        ) : null}
      </Dialog>
      <Dialog
        open={openResetDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="xs"
      >
        {openResetDrawer ? (
          <ResetPassword
            selectedData={selectedData}
            setOpenDrawer={setOpenResetDrawer}
            formType={
              selectedData.isView ? "view" : selectedData._id ? "edit" : "add"
            }
            // getData={getClientData}
          />
        ) : null}
      </Dialog> */}
    </Card>
  );
};

export default EditEmployee;
